import img from './Kalenderhaus_Ladeanzeige.gif';

export default function Loading() {
  return (
    <div>
      <img src={img} />
    </div>
  );
}
